<template>
  <div class="form-url-holder">
    <transition name="section" mode="out-in" tag="div">
      <div class="url-form">
        <form @submit.prevent="preloadUrl() && submit()" class="url-form__form">
          <div class="form-field__default" :class="{error: !!urlError}">
            <label for="url-input" class="label__default">
              Enter Page URL
              <span class="error" v-if="urlError"> - {{ urlError }}</span>
            </label>
            <input v-model="rawUrl" class="input-field__default" placeholder="http://your-bridge-page-link.com" @input="debouceUrl"/>
          </div>
          <div class="form-button__addition">
            <button class="form-button__default form-button__static submit" :disabled="!this.approvedDisclaimer">
              <transition name="fade" mode="out-in">
                <div v-if="!validating && $store.state.rotator.activeType < 0">
                  GO
                </div>
                <div v-else class="el-loading-spinner">
                  <svg viewBox="25 25 50 50" class="circular">
                    <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                  </svg>
                </div>
              </transition>

            </button>
          </div>
          <el-checkbox v-model="approvedDisclaimer">I agree to the stated <a href="">terms</a> and <a href="">conditions</a></el-checkbox>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
const debounce = require('debounce');

export default {
  name: 'URL',

  data() {
    return {
      approvedDisclaimer: false,
      validating        : false,
      debouceUrl        : debounce(this.preloadUrl, 300),
      rawUrl            : '',
      errors            : {}
    }
  },

  computed: {
    // Normalize trailing /'s and ensure protocol is set
    url() {
      const url = this.rawUrl.trim().replace(/(\/+)?(#.*)?$/, '')
      return /^https?:/i.test(url)? url: ('http://' + url)
    },
    urlError() {
      return (this.errors.urlError && 'URL should not be empty') || this.$store.state.rotator.preloadError || false;
    }
  },

  watch: {
    '$store.state.rotator.preloading'(newVal, oldVal) {
      // The preload URL finished loading while we're inside the validation process
      if (this.validating && !newVal)
        this.submit()
    },
    '$store.state.rotator.overrideUrl'(newVal, oldVal) {
      if (newVal && newVal !== '') {
        this.rawUrl = newVal
        this.$store.commit('setOverrideUrl', false)

        this.$nextTick(() => {
          this.preloadUrl()
          this.submit()
        })
      }
    }
  },

  methods: {
    preloadUrl() {
      return this.$store.dispatch('setPreloadSettings', { url: this.url, status: !!this.url, error: false }) || true
    },
    // Form validation
    validate() {
      // URL empty
      this.$set(this.errors, 'urlError', !this.url)
      return !Object.values(this.errors).some((val) => { return val !== false }) && !this.urlError
    },

    // Send
    submit() {
      if (!this.approvedDisclaimer)
        return
      
      this.validating = this.$store.state.rotator.preloading
      
      // URL is already active
      if (this.url == this.$store.state.rotator.activeUrl)
        this.$emit('submit')
      
      // Make sure the preloading process has stopped and that it finished successfully
      if (this.url == this.$store.state.rotator.preloadUrl && this.$store.getters.preloaded && this.validate()) {
        this.errors = {}
        this.$store.dispatch('setActiveUrl', this.url)
        this.$emit('submit')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~static/mixins/global';
@import '~static/mixins/variables';

.el-loading-spinner {
    position  : relative;
    height    : 21px;
    margin-top: 0;
    top       : -6px;
    left      : -1px;
}
.el-loading-spinner .circular{
  display       : inline-block;
  vertical-align: -webkit-baseline-middle;
  overflow      : hidden;
  height        : 30px;
  width         : 30px;
}
.el-loading-spinner .path {
  stroke: #fff;
}
.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  height : 0;
  opacity: 0;
}

.form-url-holder {
  padding              : 50px 0;
  background           : linear-gradient(45deg, rgba(255, 255, 255, 1) 0%, rgba(160, 206, 217, 1) 100%);
  background-attachment: fixed;
  background-size      : cover;
  height               : inherit;
  display              : flex;
}

.url-form
{ /*URL FORM*/
  width         : 650px;
  margin        : auto;
  text-align    : left;
  display       : block;
  vertical-align: middle;

  .el-checkbox {
    text-align: center;
    width     : 100%;

    a {
      font-weight: bold;
    }
  }

  .url-form__form,
  .url-form__headers {
    display: inline-block;
  }
  .error {
    color              : #ff0000;
    border-color       : red;
    animation          : shake .5s linear;
    line-height        : 20px;
    vertical-align     : bottom;
    animation-fill-mode: forwards;
  }
  span.error {
    opacity: 0;
  }
  .url-form__form {
    vertical-align: middle;
    width         : 100%;
    position      : relative;
  }
  .disabled {
    background: #e0e0e0;
    width     : $width-full;
    text-align: $font-left;
    height    : 55px;
    z-index   : 2;
    @include borderRadius(5px);
    @include placementBundle(absolute, 0, inherit, inherit, 0);

    .disabled-headline {
      line-height   : 55px;
      padding       : 0 25px;
      text-transform: uppercase;
      color         : #afafaf;
      @include fontStyleBundle($font-family-poppins, $font-size-body-large, normal, normal)
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all .3s;
  }
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-to {
    opacity: 1;
  }
  .section-enter-active,
  .section-leave-active {
    position: relative;
    @include transitionBundle(all, .6s);
  }
  .section-leave-active {
    left      : 0;
    opacity   : 1;
    visibility: visible;
  }
  .section-enter-active {
    left   : 95px;
    opacity: 0;
    height : 0;
    padding: 0;
  }
  .section-leave-to {
    opacity: 0;
    left   : 95px;
  }
  .section-enter-to {
    opacity: 1;
    left   : 0;
  }
  .submit > div {
    height    : 21px;
    width     : 26px;
    text-align: center;
  }
}

span.error {
  color      : #ff0000;
  font-size  : 12px;
  font-weight: normal;
  padding    : 0 0 0 3px;
}

.btn {
  cursor: pointer;
}

@keyframes shake {
  0%, 41% {
      -webkit-transform: translateX(-5px);
  }
  25%, 58% {
      -webkit-transform: translateX(5px);
  }
  75% {
      -webkit-transform: translateX(-2.5px);
  }
  92% {
      -webkit-transform: translateX(2.5px);
  }
  100% {
      -webkit-transform: translateX(0);
      opacity          : 1;
  }
}
</style>



// WEBPACK FOOTER //
// URL.vue?8652b8cc